'use es6';

import actionTypes from 'ContentEditorUI/redux/actions/inpageActionTypes';
import { LAYOUT_SECTION_TRACKING_MESSAGES, DRAG_AND_DROP_AREA_ACTION } from 'ContentEditorUI/lib/layoutSection/constants';

// Note, these are not treated as real Redux actions. They are structured like actions,
// but they will be received as post message events in the parent.
// More info in inpageActionTypes.js

export const updateContainers = containers => {
  return {
    type: actionTypes.UPDATE_CONTAINERS,
    containers
  };
};
export const logLayoutSectionEvent = (logType, logData) => {
  return {
    type: actionTypes.LOG_LAYOUT_SECTION_EVENT,
    data: Object.assign({
      action: DRAG_AND_DROP_AREA_ACTION,
      event: LAYOUT_SECTION_TRACKING_MESSAGES[logType]
    }, logData)
  };
};
export const trackInpageUsageEvent = eventData => ({
  type: actionTypes.TRACK_INPAGE_USAGE_EVENT,
  eventData
});